window.onload = function() {
    gsap.registerPlugin(ScrollTrigger);
    const sections = document.querySelectorAll("#MainContent .shopify-section");

    createScrollChangeColor(sections, "top top", changeColorHeader);

    function createScrollChangeColor(sections, start, callBack) {
      sections.forEach((section, index) => {
        console.log(section.offsetTop);
        ScrollTrigger.create({
          trigger: section,
          start: start,
          end: "bottom bottom",
          onEnter: () => callBack(section),
          onLeaveBack: () => callBack(section.previousElementSibling),
        });
      });
    }

    function changeColor (section, elements, defaultColor) {
        console.log(section);
        const color = section?.querySelector("[data-color]")?.getAttribute("data-color") || defaultColor;
        const background = section?.querySelector("[data-bg]")?.getAttribute('data-bg') || "#000000";
        const animate = (selector, properties) => gsap.to(selector, {
          duration: 0,
          ease: CustomEase.create("custom", "M0,0 C0.871,0.1 0.258,0.961 1,1 "),
          ...properties,
        });
    
        elements.forEach(([selector, property]) => {
          animate(selector, { [property]: property === 'backgroundColor' ? background : color });
        });
    }

    function changeColorHeader(section) {
        changeColor(section, [
          ['.header__wrap ', 'backgroundColor'],
          ['.header__menu-item', 'color'],
          ['.header__heading-logo-wrapper svg path', 'fill'],
          ['.header__icon', 'borderColor'],
          ['.header__icon svg path', 'fill']
        ], "#ff8ec7");
      }
};